import { render } from "./GalleryDesignLink.vue?vue&type=template&id=8a9bcd88&scoped=true"
import script from "./GalleryDesignLink.vue?vue&type=script&lang=js"
export * from "./GalleryDesignLink.vue?vue&type=script&lang=js"

import "./GalleryDesignLink.vue?vue&type=style&index=0&id=8a9bcd88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9bcd88"]])

export default __exports__